// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-g_gm","galleryThumbnail__image":"c-g_gn"};